(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["admin-stock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const board = document.querySelector('[data-stock-board]');
    if (!board) return;

    const LOW = 2;
    const rows = [...board.querySelectorAll('.stock-board__row')];
    const messageEl = board.querySelector('[data-message]');
    const noteEl = board.querySelector('[data-note]');

    const stamp = board.querySelector('[data-stamp]');
    const today = new Date().toLocaleDateString(undefined, {
      day: 'numeric', month: 'long', year: 'numeric',
    });
    if (stamp) stamp.textContent = today;

    const inputsOf = (row) => [...row.querySelectorAll('.stock-board__input')];
    const valueOf = (input) => {
      const n = parseInt(input.value, 10);
      return Number.isFinite(n) && n >= 0 ? n : 0;
    };

    function paintRow(row) {
      const inputs = inputsOf(row);
      let total = 0;
      let changed = false;

      inputs.forEach((input) => {
        const now = valueOf(input);
        const was = parseInt(input.dataset.original, 10);
        total += now;
        input.dataset.zero = String(now === 0);
        input.dataset.low = String(now > 0 && now <= LOW);
        input.dataset.changed = String(now !== was);
        if (now !== was) changed = true;
      });

      // Pre-order only holds while the row is genuinely empty. The moment
      // someone types a count in, it is a normal in-stock product again.
      const wasPreorder = row.querySelector('[data-tag]').dataset.preorder === 'true';
      const preorder = wasPreorder && total === 0;

      const tag = row.querySelector('[data-tag]');
      if (preorder) {
        tag.dataset.state = 'pre';
        tag.textContent = 'Pre-order';
      } else if (total === 0) {
        tag.dataset.state = 'out';
        tag.textContent = 'Sold out';
      } else if (total <= 3) {
        tag.dataset.state = 'low';
        tag.textContent = total + ' left';
      } else {
        tag.dataset.state = 'stock';
        tag.textContent = total + ' in stock';
      }

      return { total, changed, preorder, wasPreorder };
    }

    function buildMessage() {
      const parts = [];
      let touched = 0;

      rows.forEach((row) => {
        const state = paintRow(row);
        if (!state.changed) return;
        touched += 1;

        const lines = [row.dataset.product];
        inputsOf(row).forEach((input) => {
          const now = valueOf(input);
          const was = parseInt(input.dataset.original, 10);
          if (now === was) return;

          let line = '  ' + input.dataset.size + ': ' + was + ' -> ' + now;
          // Say what the change means, not just the arithmetic — these are the
          // two transitions that actually need acting on in admin.
          if (now === 0) line += '  (sold out)';
          else if (was === 0) line += '  (back in stock)';
          lines.push(line);
        });

        if (state.wasPreorder && state.total > 0) {
          lines.push('  ^ was on pre-order, now has real stock');
        }
        parts.push(lines.join('\n'));
      });

      if (!touched) {
        messageEl.textContent =
          'No changes yet.\n\nChange any number above and the message to send will appear here.';
        return;
      }

      const note = (noteEl.value || '').trim();
      const head = 'FWR stock update - ' + today;
      const tail = touched === 1 ? '1 product changed.' : touched + ' products changed.';

      // Blank lines are load-bearing here: this gets pasted into a text message,
      // so the spacing is what makes it scannable on a phone.
      const chunks = [head, '', parts.join('\n\n'), '', tail];
      if (note) chunks.push('Note: ' + note);

      messageEl.textContent = chunks.join('\n');
    }

    board.addEventListener('input', buildMessage);

    board.querySelector('[data-reset]').addEventListener('click', () => {
      board.querySelectorAll('.stock-board__input').forEach((input) => {
        input.value = input.dataset.original;
      });
      noteEl.value = '';
      buildMessage();
    });

    const copyBtn = board.querySelector('[data-copy]');
    copyBtn.addEventListener('click', async () => {
      const text = messageEl.textContent;
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        // Clipboard API needs a secure context and permission; select the text
        // so a long-press or ctrl+C still works when it is refused.
        const range = document.createRange();
        range.selectNodeContents(messageEl);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      const original = copyBtn.textContent;
      copyBtn.textContent = 'Copied';
      setTimeout(() => { copyBtn.textContent = original; }, 1600);
    });

    buildMessage();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
